<template>
  <div class="box">
    <div class="box-in">
      <!-- <img src="../assets/img/logo.svg" @click="checkNav('/')" alt="saxo" class="logo fl" /> -->
      <!-- <span class="logo-m" @click="checkNav('/')">{{ $t("nav.logo") }}</span> -->
      <img
        :src="$i18n.locale === 'en' ? require('../assets/img/logo-horizontal-en.png') : require('../assets/img/logo-horizontal.png')"
        @click="checkNav('/')" alt="saxo" class="logo fl" />
      <ul class="tab fl">
        <li class="cup" :class="[tab == '/' ? 'atv' : '']" @click="checkNav('/')">{{ $t("nav.tab1") }}</li>
        <li class="cup" :class="[aboutAct]" @click="showChildMenu" data-menu="about">{{ $t("nav.tab2") }}</li>
        <li class="cup" @click="showChildMenu" data-menu="join">{{ $t("nav.tab3") }}</li>
        <li class="cup" :class="[tab == '/contact' ? 'atv' : '']" @click="checkNav('/contact')">{{ $t("nav.tab4") }}</li>
      </ul>
      <div class="i18n fr" @click="changeLanguage()">
        <span :class="this.$i18n.locale == 'zh' ? 'atv' : ''">{{ $t("nav.zh") }}</span> /
        <span :class="this.$i18n.locale != 'zh' ? 'atv' : ''">{{ $t("nav.en") }}</span>
      </div>
    </div>
    <div class="children-box">
      <div class="child-menu childAbout" ref="child-about" v-show="showAboutSubMenu">
        <div @click="checkNav('/about')" :class="{ acitveSub: tab == '/about' }">
          {{ $t("nav.tab2_1") }}
          <img src="@/assets/img/more.png" />
        </div>
        <div @click="checkNav('/news')" :class="{ acitveSub: tab == '/news' }">
          {{ $t("nav.tab2_2") }}
          <img src="@/assets/img/more.png" />
        </div>
      </div>
      <div class="child-menu childJoin" ref="child-join" v-show="showJoinSubMenu">
        <a v-bind:href="joinUsSocialLink" target="_blank">
          {{ $t("nav.tab3_1") }}
          <img src="@/assets/img/more.png" />
        </a>
        <a v-bind:href="joinUsCampusLink" target="_blank">
          {{ $t("nav.tab3_2") }}
          <img src="@/assets/img/more.png" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from '../assets/js/bus'
export default {
  name: 'Nav',
  components: {},
  data() {
    return {
      tab: '/',
      showAboutSubMenu: false,
      showJoinSubMenu: false,
      joinUsSocialLink: process.env.VUE_APP_MOKA_SOCIAL_LINK || '',
      joinUsCampusLink: process.env.VUE_APP_MOKA_CAMPUS_LINK || ''
    };
  },
  computed: {
    aboutAct() {
      var tab = this.tab;
      var flag = tab == "/about" || tab.indexOf("/news") > -1;

      if (flag) {
        return "atv"
      }
    }
  },
  methods: {
    changeLanguage() {
      this.$i18n.locale == 'zh' ? this.$i18n.locale = 'en' : this.$i18n.locale = 'zh'   //设置中英文模式
      localStorage.setItem('languageSet', this.$i18n.locale)   //将用户设置存储到localStorage以便用户下次打开时使用此设置
      window.$vrm.$emit('lang-change', this.$i18n.locale)
    },
    // remind(){
    //     this.$toast(this.$t('user.loginUsername'))
    // },
    checkNav(url) {
      if (url != this.tab) {
        this.tab = url
        this.$router.push(url)
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        window.pageYOffset = 0
      }
    },

    showChildMenu(e) {
      // debugger
      //this.hideAllChildren();
      var li = e.target;
      var bcr = li.getBoundingClientRect();

      var left = bcr.left + (bcr.width - 80) / 2;
      var moduleName = li.dataset.menu
      if (moduleName === 'join') {
        this.showAboutSubMenu = false
        this.showJoinSubMenu = !this.showJoinSubMenu
      } else if (moduleName === 'about') {
        this.showJoinSubMenu = false
        this.showAboutSubMenu = !this.showAboutSubMenu
      }
      var menu = this.$refs['child-' + moduleName];
      menu.style.left = left + "px";
      // menu.style.display = menu.style.display == "block" ? 'none' : "block";
    },
    hideAllChildren() {
      this.showAboutSubMenu = false;
      this.showJoinSubMenu = false;
    },
    clickBlankArea(evt) {
      if ((this.showAboutSubMenu || this.showJoinSubMenu) && !this.$el.contains(evt.target)) {
        this.hideAllChildren()
      }
    }
  },
  created() {
    Bus.$on("nav", nav => {
      this.tab = nav
    })
    this.tab = this.$route.path
    document.addEventListener('click', this.clickBlankArea)
  }
}
</script>

<style scoped lang="less">
.box {
  width: 100%;
  background: #fff;
  height: 90px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);

  .box-in {
    width: 1260px;
    overflow: visible;
    margin: 0 auto;

    .logo {
      height: 60px;
      margin-top: 15px;
      margin-left: 30px;
      cursor: pointer;
      float: left;
      vertical-align: middle;
    }

    .logo-m {
      display: block;
      float: left;
      line-height: 90px;
      margin-left: 16px;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      color: #3d434d;
      -moz-user-select: none;
      /* Firefox私有属性 */
      -webkit-user-select: none;
      /* WebKit内核私有属性 */
      -ms-user-select: none;
      /* IE私有属性(IE10及以后) */
      -khtml-user-select: none;
      /* KHTML内核私有属性 */
      -o-user-select: none;
      /* Opera私有属性 */
      user-select: none;
      /* CSS3属性 */
      cursor: pointer;
    }

    .tab {
      height: 90px;
      margin-left: 40px;

      li {
        float: left;
        line-height: 90px;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        color: #3d434d;
        padding: 0 30px;
        position: relative;
        -moz-user-select: none;
        /* Firefox私有属性 */
        -webkit-user-select: none;
        /* WebKit内核私有属性 */
        -ms-user-select: none;
        /* IE私有属性(IE10及以后) */
        -khtml-user-select: none;
        /* KHTML内核私有属性 */
        -o-user-select: none;
        /* Opera私有属性 */
        user-select: none;
        /* CSS3属性 */
      }

      .atv::before {
        position: absolute;
        width: 60px;
        height: 4px;
        background: #2284f6;
        border-radius: 16px;
        margin-left: -30px;
        content: "";
        top: 0;
        left: 50%;
      }

      .atv {
        font-weight: 600;
      }
    }
  }

  .i18n {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 90px;
    color: #3d434d;
    margin-right: 30px;
    cursor: pointer;
    -moz-user-select: none;
    /* Firefox私有属性 */
    -webkit-user-select: none;
    /* WebKit内核私有属性 */
    -ms-user-select: none;
    /* IE私有属性(IE10及以后) */
    -khtml-user-select: none;
    /* KHTML内核私有属性 */
    -o-user-select: none;
    /* Opera私有属性 */
    user-select: none;

    /* CSS3属性 */
    .atv {
      color: #2284f6;
    }
  }

  .children-box {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: rgba(243, 244, 245, 1);

    .child-menu {
      position: relative;
      width: 80px;
      padding: 10px 0;
      padding-left: 10px;
      // display: none;

      &::before {
        content: "";
        display: block;
        position: absolute;
        border: 10px solid transparent;
        border-bottom: 10px solid rgba(243, 244, 245, 1);
        bottom: 100%;
        left: 50%;
        margin-left: -10px;
      }

      div,
      a {
        color: #3d434d;
        display: flex;
        align-items: center;
        padding: 12px 0;
        cursor: pointer;
        white-space: nowrap;

        img {
          display: block;
          height: 10px;
          margin-left: 8px;
        }
      }

      .blue {
        color: #2284f6;
      }
    }

    .child-menu.show {
      display: block;
    }

    .acitveSub {
      color: #2284f6 !important;

      // img {
      //   display: block !important;
      // }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/nav.vue